<template>
	<div class="honor">
		<p>COMPANY HONOR</p>
		<h3>荣誉资质</h3>
		<div class="container">
			<div class="list">
				<div class="title">
					荣誉资质列表
				</div>
				
				<div class="lists">
					<ul>
						<li v-for="item in aptitude">
							<div class="lists-li">
								<img :src="item.imgUrl"/>
							</div>
							<p>{{item.title}}</p>
						</li>
					</ul>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'honor',
				aptitude:[]
			}
		},
		methods:{
			getData(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.aptitudeApi,
				})
				.then((res) => {
					this.aptitude = res.data.data;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.$parent.getItem();
			this.getData();
		}
	}
</script>

<style lang="less" scoped="scoped">
.honor{
	P{
		margin-top: 50px;
		font-size: 26px;
		color: #00A0FF;
		text-align:center;
	}
	h3{
		margin-top: 10px;
		font-size: 26px;
		font-weight: 600;
		margin-bottom: 50px;
		text-align:center;
	}
	/*height: 750px;*/
	margin-bottom: 70px;
	.list{
		width: 100%;
		height: 100%;
		.title{
			width: 100%;
			height: 45px;
			background: #00A0FF;
			color: #fff;
			line-height: 45px;
			padding-left: 30px;
		}
		.lists{
			padding: 30px;
			border-left: 1px solid #ccc;
			border-right: 1px solid #ccc;
			border-bottom: 1px solid #ccc;
			ul{
				display: flex;
				flex-wrap: wrap;
				justify-content: flex-start;
				li{
					display: inline-block;
					width: 24%;
					height: 350px;
					margin-bottom: 25px;
					position: relative;
					border-radius:5px;
					margin-right:11px;
					overflow:hidden;
					p{
						position: absolute;
						width: 100%;
						height: 14%;
						background: #00A0FF;
						bottom: 0px;
						left: 0px;
						text-align: center;
						line-height: 45px;
						color:#fff;
						font-size:1rem;
					}
					.lists-li{
						width: 100%;
						height: 86%;
						img{
							width: 100%;
							height: 100%;
							z-index: -1;
						}
					}					
				}
				li:hover{
					transform:scale(1.01,1.01);
					box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/About/Acom/Honor.vue